import React from "react";

const Footer: React.FC = () => {
  return (
    <div className="relative overflow-hidden py-8 md:py-20">
      <div className="w-full mx-auto max-w-[94.25em] px-[1.5em] md:px-[2.5em]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-0 relative z-[1]">
          <div className="flex flex-col justify-between gap-5 w-full lg:pr-6 order-1 lg:order-[0]">
            <div className="flex flex-col gap-6">
              <p className="text-white text-lg md:text-xl font-medium w-full lg:max-w-[375px]">
                We know you are busy, so let's get straight to it.
              </p>
              <a
                href="mailto:hello@thedevify.com"
                className="text-white text-2xl md:text-[32px] xl:text-[36px] leading-[1.2] font-light"
              >
                sales@unity-dev.com
              </a>
            </div>
            <div className="flex flex-col gap-4 md:gap-6">
              <div className="flex flex-wrap gap-5">
                <a
                  className="text-white text-base md:text-lg leading-[1.4]"
                  href="#about"
                >
                  About Us
                </a>
                <a
                  className="text-white text-base md:text-lg leading-[1.4]"
                  href="#services"
                >
                  Services
                </a>
                <a
                  className="text-white text-base md:text-lg leading-[1.4]"
                  href="#calculation"
                >
                  Get a Quote
                </a>
                <a className="text-white text-base md:text-lg leading-[1.4]">
                  Linkedin
                </a>
              </div>
              <div className="text-white text-base md:text-lg text-center lg:text-left">
                Copyright 2025
              </div>
            </div>
          </div>
          <div className="rounded-2xl sm:rounded-s-3xl md:rounded-[32px] py-8 px-6 md:px-10 md:pb-10 w-full bg-white border border-[#181823] order-[0] lg:order-1">
            <div className="flex flex-col gap-4 border-b border-[#525258] pb-6">
              <h5 className="text-[#0E0E13] text-base md:text-lg font-medium tracking-wider">
                Contact us!
              </h5>
              <p className="text-[#0E0E13] text-base md:text-lg font-medium">
                Let's discuss your project, or together we will find a solution
                to the most difficult tasks
              </p>
            </div>
            <form className="w-full mt-8 md:mt-12">
              <div className="flex flex-col gap-3 mb-4">
                <div className="w-full relative">
                  <input
                    type="text"
                    placeholder="Your Full Name"
                    className="w-full text-white text-sm font-normal rounded-xl py-[14px] px-5 bg-[#181823] focus:outline-none focus:shadow-none"
                  />
                </div>
                <div className="w-full relative">
                  <input
                    type="email"
                    placeholder="Email"
                    className="w-full text-white text-sm font-normal rounded-xl py-[14px] px-5 bg-[#181823] focus:outline-none focus:shadow-none"
                  />
                </div>
                <div className="w-full relative">
                  <input
                    type="text"
                    placeholder="Phone"
                    className="w-full text-white text-sm font-normal rounded-xl py-[14px] px-5 bg-[#181823] focus:outline-none focus:shadow-none"
                  />
                </div>
                <div className="w-full relative">
                  <input
                    type="text"
                    placeholder="Company Name / VAT"
                    className="w-full text-white text-sm font-normal rounded-xl py-[14px] px-5 bg-[#181823] focus:outline-none focus:shadow-none"
                  />
                </div>
              </div>
              <p className="text-[#0E0E13] text-sm font-medium text-center mb-4">
                By clicking on the button below, you accept our
              </p>
              <button
                type="submit"
                className="py-3 md:py-4 px-5 md:px-6 bg-[#181823] rounded-[5.56em] text-white text-base leading-[1.2] font-medium transition-all duration-300 border-none hover:bg-[#343436] focus:bg-[#343436] w-full"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="absolute top-0 left-0 w-[375px] h-[375px] bg-[#BE261D] blur-[9.375em] opacity-20 rounded-[6.25em] translate-x-[-50%] translate-y-[-50%] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[75em] h-[75em] bg-[#1E1B45] blur-[9.375em] rounded-[50%] translate-x-[-40%] translate-y-[50%] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[31.25em] h-[31.25em] bg-[#DF7716] blur-[9.375em] opacity-20  rounded-[50%] translate-x-[40%] translate-y-[60%] pointer-events-none" />
    </div>
  );
};

export default Footer;
